module.exports = __webpack_public_path__ + "static/15-2-7d5ea3a4baac048c13fbea958c4904a7.jpg";